var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo40(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 347.168,
    height: 79.498,
    viewBox: "0 0 347.168 79.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 8.148,
    y1: -0.181,
    x2: 8.093,
    y2: 1.07,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#13bdc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#10b4c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#069aaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#028ea6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#108196"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 6.75,
    y1: -0.181,
    x2: 6.697,
    y2: 1.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.206,
    y1: -0.161,
    x2: 1.157,
    y2: 1.054,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.079,
    y1: -0.181,
    x2: 0.037,
    y2: 1.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -1.159,
    y1: -0.18,
    x2: -1.205,
    y2: 1.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -2.117,
    y1: -0.181,
    x2: -2.16,
    y2: 1.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -3.7,
    y1: -0.181,
    x2: -3.748,
    y2: 1.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -5.448,
    y1: -0.181,
    x2: -5.501,
    y2: 1.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -5.127,
    y1: -0.181,
    x2: -5.168,
    y2: 1.07,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-3.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(3.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M255.093,35.506A82.088,82.088,0,0,0,241.984,32.8a2.824,2.824,0,0,1-2.667-3.261l1.05-4.92s-14.9,5.949-20.2,11.468c0,0,6.677-15.331,13.224-24.1l-5.473.934a5.109,5.109,0,0,1-5.981-3.849L220.364,0,207.416,13.3a5.333,5.333,0,0,1-6.771.528L198.6,12.385s-.427,18.491.595,25.385l-11.6-7.184.7,3.1a4.819,4.819,0,0,1-4.528,5.683l-9.543.959,6.757,9.711a3.486,3.486,0,0,1-1.5,5.218l-2.975,1.4s11.636.8,20.384,5.508a2.45,2.45,0,0,1,1.253,2.9l-1.417,4.29a24.017,24.017,0,0,1,8.983-3.15,59.618,59.618,0,0,1,6.044-37.406,67.19,67.19,0,0,0-4.262,20.479c-1.606,17.781,5.452,30.1,5.452,30.1l1.232.1a2.347,2.347,0,0,0,2.425-3.5,42.491,42.491,0,0,1-4.63-9.847,24.206,24.206,0,0,1,8.84,2.884l-.794-6.82a2.723,2.723,0,0,1,1.519-2.719c3.447-1.8,12.171-5.7,27.033-8.192l-3.849-3.286a2.551,2.551,0,0,1-.2-3.821C247.2,41.476,252.09,36.849,255.093,35.506Z",
    transform: "translate(-116.265)",
    fill: "#ceaf82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M8.61,51.05h8.084V95.143h13.3v7.349H8.61Z",
    transform: "translate(-8.61 -33.185)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M80.85,51.05H102.9V58.4H88.951v13.6h11.1v7.349h-11.1v15.8h13.963v7.349H80.868Z",
    transform: "translate(-55.57 -33.185)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M424.39,89.166V61.52c0-7.937,4.115-12.64,11.9-12.64s11.9,4.7,11.9,12.64v5.438h-7.629V61.009c0-3.359-1.606-4.738-4.056-4.738s-4.042,1.4-4.042,4.777V89.782c0,3.38,1.617,4.7,4.042,4.7s4.042-1.323,4.042-4.7V81.9h7.643v7.265c0,7.937-4.115,12.64-11.9,12.64S424.39,97.113,424.39,89.166Z",
    transform: "translate(-278.889 -31.775)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M508.578,51.05h10.95l8.378,51.442h-8.084l-1.47-10.215v.147h-9.186l-1.47,10.068h-7.5ZM517.4,85.443l-3.6-25.427h-.147l-3.528,25.427Z",
    transform: "translate(-328.17 -33.185)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M590.49,51.017h10.148L608.516,81.8h.147V51h7.2v51.442h-8.322l-9.7-37.535h-.147V102.46h-7.2Z",
    transform: "translate(-386.863 -33.153)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M682.444,51.05H693.4l8.378,51.442h-8.084l-1.47-10.215v.147h-9.186l-1.47,10.068h-7.5Zm8.819,34.393-3.6-25.427h-.147l-3.528,25.427Z",
    transform: "translate(-441.195 -33.185)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M764.37,51.05h12.346c8.084,0,12.052,4.483,12.052,12.714V89.779c0,8.231-3.968,12.714-12.052,12.714H764.37Zm12.2,44.093c2.572,0,4.115-1.323,4.115-5V63.4c0-3.674-1.543-5-4.115-5h-4.115V95.143Z",
    transform: "translate(-499.895 -33.185)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M849.63,51.05h22.047V58.4H857.714v13.6h11.1v7.349h-11.1v15.8h13.963v7.349H849.63Z",
    transform: "translate(-555.318 -33.185)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M929.326,76.183l-8.9-25.133h8.525L934.4,67.658h.147l5.6-16.608h7.643L938.9,76.183l9.333,26.309h-8.542l-5.879-17.931h-.161l-6.026,17.931H920Z",
    transform: "translate(-601.063 -33.185)",
    fill: "url(#linear-gradient-9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo40);
export default __webpack_public_path__ + "static/media/Logo40.f91f0f9866e9ad63413d153e0252f89c.svg";
export { ForwardRef as ReactComponent };